import React, { useState } from 'react'
import dayjs from 'dayjs'

import { Input, INPUT_THEME, Pagination, usePagination } from '@st-operations/uikit/src/v2'

import Table from '_components/table'
import ItemInfoCell from '_components/item-info-cell'

import './styles.scss'

const LogsTab = ({ logs = [] }) => {
  const [search, setSearch] = useState('')
  const { page, toPage } = usePagination(
    logs
      .filter(({ name }) => !search || name.toLowerCase().includes(search.toLowerCase()))
      .sort((a, b) => {
        if (a.createdAt < b.createdAt) return 1
        if (a.createdAt > b.createdAt) return -1
        return 0
      }),
    20
  )

  const handleSearch = (value) => setSearch(value)

  return (
    <>
      <div className="bpa-process__table-header">
        <Input
          theme={INPUT_THEME.SEARCH}
          placeholder="Search Audiences"
          value={search}
          onChange={handleSearch}
        />
        <Pagination
          options={{ length: page.quantity }}
          page={page.number - 1}
          onPageChange={(page) => toPage(page.label)}
        />
      </div>
      <Table
        columns={[
          {
            name: 'Name',
            key: 'name',
            width: 400,
            render: (item) => (
              <ItemInfoCell
                item={item}
                key={`item-${item.index}`}
                href={`/audience-creator/${item._id}`}
              />
            ),
          },
          {
            name: 'Approval Process Status',
            key: 'status',
          },
          {
            name: 'Message',
            key: 'message',
            render: (item) => <span title={item.message}>{item.message}</span>,
            width: 300,
          },
          {
            name: 'Process ID',
            key: 'processId',
            render: (item) => <span title={item.processId}>{item.processId}</span>,
          },
          {
            name: 'Created At',
            key: 'createdAt',
            render: (item) => dayjs(item.createdAt).format('MM/DD/YYYY HH:mm:ss'),
          },
        ]}
        sort_key={'createdAt'}
        data={page.content}
      />
    </>
  )
}

export default LogsTab
